module.exports = __webpack_public_path__ + "static/media/rainy-3.c17e7a5d.svg";